// extracted by mini-css-extract-plugin
export default {"about__text":"About-module__about__text--zLzj9"};